import { InjectionToken } from '@angular/core';
import { IAppConfig } from './iapp.config';
import { environment } from 'environments/environment';

export let APP_CONFIG = new InjectionToken<IAppConfig>('app.config');

const API_URL = environment.apiUrl;

export const AppConfig = {
  // Време за изчакване на потвърждение за вход (от приложението)
  loginTime: 200,
  repeatTimeout: 3000,
  pullCertificateStatusTimeout: 5000,
  pullSigningTimeout: 2000,
  paymentStatusTimeout: 10000,
  certificateStatusTimeout: 3000,
  routes: {
    login: 'login',
    activation: 'activation/:uuid',
    accounts: 'accounts',   
    authenticated: 'authenticated',
    profile: {
      main: 'profile',
      settings: 'profileSettings',
    },
    certificates: {
      main: 'certificates',
      sign: 'signing',
      manage: 'manage',
      devices: 'devices',
      packs: 'packs',
      history: 'history',
      consents: 'consents',
      profile: 'profile',
      hardwareCertificates: 'hardwareCertificates',
      menageHardwareCertificates: 'menageHardwareCertificates',
      certificateHistory: 'certificateHistory'
    },
    business: {
      main: 'business',
      sign: 'signing',
      signing: 'business/sign',
      identification: 'identification',
      history: 'history',
      archive: 'archive',
      hardwareCertificates: 'hardwareCertificates',
      reports: 'reports',
      profile: 'profile',
      sendForSigning: 'sendForSigning',
      menageHardwareCertificates: 'menageHardwareCertificates',
      certificateHistory: 'certificateHistory',
      signingotc: 'signingotc'
    },
    error404: '404'
  },
  endpoints: {
    authenticate: {
      byId: API_URL + '/login/byId',
      getQrCode: API_URL + '/login/getQrCode',
      authenticate: API_URL + '/login/authenticate',
      logout: API_URL + '/login/destroy'
    },
    operations: {
      sign: API_URL + '/operations/signDoc',
      sendPackage: API_URL + '/operations/sign/parcel',
      downloadReceipt: API_URL + '/operations/sign/evidence/receipt',
      // getAll: API_URL + '/certificates/getAll', - certificates GET
      hold: API_URL + '/operations/hold',
      restore: API_URL + '/operations/restore',
      addDevice: API_URL + '/operations/addDevice',
      checkDevice: API_URL + '/operations/device/bindResult',
      getSignDocStatus: API_URL + '/operations/getSignDocStatus',
      getCertificate: API_URL + '/operations/certificate',
      certificateStatus: API_URL + '/operations/certificate/certReqId/status',
      preview: API_URL + '/operations/document/preview',
      sendPackageOtc: API_URL + '/business/{companyCrmId}/identification/signsession/{sessionId}/{resultId}/{status}/start',
    },
    certificates: API_URL + '/certificates',
    certificatesReportData: API_URL + '/business/company/{eik}/qes',
    excellFormatReport: API_URL + '/business/company/{eik}/qes/excelFile',
    servicesAvailableUser: API_URL + '/business/company/{companyId}/employee/{cmrId}/services',
    searchForManagementRequests: API_URL + '/business/qes/management/search',
    createReportForManagementRequestsExcell: API_URL + '/business/qes/management/search/excelFile',
    managementHistory: API_URL + '/business/qes/managementHistory/{serialNumber}',
    managementHistorysExcell: API_URL + '/business/qes/managementHistory/{serialNumber}/excelFile',
    devices: API_URL + '/devices',
    consents: API_URL + '/consents',
    bissLogin: API_URL + '/login/biss',
    eventLog: API_URL + '/eventLog',
    companies: API_URL + '/business/employee/{personId}/company',
    company: API_URL + '/business/company/{companyId}/details',
    userAccess: API_URL + '/business/company/{companyId}/employee/{cmrId}/services',
    services: API_URL + '/business/services',
    person: API_URL + '/business/person/info',
    rolesUser: API_URL + '/business/roles',
    servicesTypes: API_URL + '/business/services',
    employees: API_URL + '/business/company/{companyId}/employees',
    employeesServices: API_URL + '/business/company/{companyId}/employee/{cmrId}/services',
    removeUserFromGroup: API_URL + '/business/group/{groupId}/employee/{customerUserId}/remove',
    deleteEmployee: API_URL + '/business/employee/{customerUserId}',
    deleteGroup: API_URL + '/business/group/{groupId}',
    employeeChangeStatus: API_URL + '/business/employee/status',
    addEmployee: API_URL + '/business/employee/register',
    editEmployee: API_URL + '/business/employee/edit',
    allGroups: API_URL + '/business/group/{companyCmrId}',
    employeeGroups: API_URL + '/business/group/{employeeCmrId}/{companyCmrId}',
    group: API_URL + '/business/group',
    packs: API_URL + '/certPacks',
    parcelDetails: API_URL + '/history/parcel/{parcelId}/details',
    parcelReject: API_URL + '/operations/sign/parcel/reject',
    viewed: API_URL + '/operations/parcel/{parcelId}/viewed',
    parcelDocIds: API_URL + '/history/parcel/{parcelId}/download',
    receiversLists: API_URL + '/business/{companyCmrId}/employee/{employeeCmrId}/recipients-lists',
    receiversList: API_URL + '/business/recipients-list/{recipientListId}',
    addReceiversList: API_URL + '/business/recipients/save',
    updateReceiversList: API_URL + '/business/recipients/update',
    identificationCallback:API_URL + '/business/{companyCmrId}/identification',
    identificationId:API_URL + '/business/{companyCmrId}/identification/{callbackId}',
    identificationHistory:API_URL + '/business/{companyCmrId}/identification',
    identificationPulling: API_URL + '/identification/{eid}/status',
    identificationExcel: API_URL + '/business/{companyCmrId}/identification/excelFile',
    downloadUEI:API_URL + '/business/{companyCmrId}/identification/{callbackId}',
    webIdentification: API_URL + '/business/{companyCmrId}/web/identification/start',
    requestsWebIdentification: API_URL + '/business/{companyCmrId}/identification/websession',
    webIdentificationHistory:API_URL + '/business/{companyCmrId}/identification/websession',
    downloadUEICreate:API_URL + '/business/{companyCmrId}/identification/web/{resultId}/result/{webssionId}/CREATE_SIGN_SESSION_REQUEST',
    downloadUEISign:API_URL + '/business/{companyCmrId}/identification/web/{resultId}/result/{signsessionId}/SIGN_SESSION',
    downloadUEIExpired:API_URL + '/business/{companyCmrId}/identification/web/{resultId}/result/{signsessionId}/EXPIRED',
    downloadIdentification:API_URL + '/business/{companyCmrId}/identification/web/{resultId}/result/{signsessionId}/IDENTIFICATION_REQUEST_DATA_AS_JSON',
    documentList: API_URL + '/business/{companyCmrId}/identification/{resultId}/documentList',
    deleteReceiversList: API_URL + '/business/employee/{employeeCmrId}/company/{companyCmrId}/recipients-list/{recipientListId}',
    storage: {
      getFile: API_URL + '/storage/getFile',
      getReport: API_URL + '/storage/getReport',
      getConsent: API_URL + '/storage/getConsent',
      getRequestedFile: API_URL + '/storage/getRequestedFile'
    },
    profile: {
      email: API_URL + '/profile/email',
      emailValidation: API_URL + '/profile/email/validation',
      validateEmail: API_URL + '/profile/validateEmail',
      phoneNumber: API_URL + '/profile/phoneNumber',
      validateOTPCode: API_URL + '/profile/validateOTPCode',
      phone: API_URL + '/profile/phone',
      remainingCount: API_URL + '/profile/remainingCount',
      search: API_URL + '/profile/search',
      getRecipientsNames: API_URL + '/profile/recipientNames',
      settings: API_URL + '/profile/settings'
    },
    orders: API_URL + '/orders',
    order: {
      paymentData: API_URL + '/order/paymentData',
      status: API_URL + '/order/status',
      mpiResponseStatus: API_URL + '/order/mpi/pull/payment/status',
      create: API_URL + '/order/create',
      companyAsPayer: API_URL + '/order/company',
      nomenclature: API_URL + '/order/nomenclature',
      invoice: API_URL + '/order/invoice'
    },
    history: {
      signing: API_URL + '/history/received',
      businessSigning: API_URL + '/history/signing/company',
      orders: API_URL + '/history/orders',
      requested: API_URL + '/history/requested',
      businessRequested: API_URL + '/history/requested/parcel/company',
      requestedDetails: API_URL + '/history/requested/details'
    },
    hardwareCert: {
      createAndProcessCqesManagementRequest: API_URL + '/business/qes/management/request/process',
      completeCqesManagementRequest: API_URL + '/business/qes/management/request/complete',
    },
    reports: {
      reportExcel: API_URL + '/business/company/{companyCmrId}/report/employees/excel',
      allReports: API_URL + '/business/company/{companyCmrId}/report/employees'
    },
    signing: {
      archive: API_URL + '/signing/archive',
    },
    emergency: {
      sendEmergencyCode: API_URL + '/emergency/sendEmergencyCode',
      validateEmergencyCode: API_URL + '/emergency/validateEmergencyCode'
    },
    activation: {
      generateOTP: API_URL + '/activation/otp/generate',
      validateOTP: API_URL + '/activation/otp/validate',
      updateActivationStep: API_URL + '/activation/status',
      finalizeCertificateActivation: API_URL + '/activation/certificate/activate',
      getActivationData: API_URL + '/activation/data/{requestUUID}',
      getSmartCardData: API_URL + '/activation/smartcard',
      generatePPProtocol: API_URL + '/activation/ppprotocol',
      consumeOrderCert: API_URL + '/activation/consumption/certificate',
      getDocument: API_URL + '/activation/document/{documentId}',
      getDocumentFull: API_URL + '/activation/document/full/{documentId}',
      invoice: API_URL + '/activation/invoice',
      biss: {
        bissAuth: API_URL + '/activation/biss/auth',
        bissDigest: API_URL + '/activation/biss/digest',
        bissCompose: API_URL + '/activation/biss/document'
      },
      getIssuedCert: API_URL + '/activation/certificate',
      uploadSignedDocuments: API_URL + '/activation/documents/upload',
      bTrustMailData: API_URL + '/activation/mail/userData',
      previewBtrustMailDocument: API_URL + '/activation/mail/document',
      activateBTrustEmail: API_URL + '/activation/mail/activate',
      getDownloadInfo: API_URL + '/activation/downloadInfo',
    }
  },
  snackBarDuration: 3000
};
